// What "Contact support" sends about the app (PMU-288): which app and version, and the last few
// things that went wrong (failed requests, script errors). Never data: paths without queries.
let recent: string[] = [];
let info: { app: string; version: string } = { app: "web", version: "web" };

export function noteError(what: string) {
  recent = [...recent, `${new Date().toISOString().slice(11, 19)} ${what.slice(0, 280)}`].slice(-10);
}
export const recentErrors = () => [...recent];
export function noteApp(app: string, version: string) { info = { app, version }; }
export const appInfo = () => info;

if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
  window.addEventListener("error", (e) => noteError(`script: ${e.message}`));
  window.addEventListener("unhandledrejection", (e) => noteError(`promise: ${String((e as PromiseRejectionEvent).reason).slice(0, 200)}`));
}
